import _styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
export function ModalContent(_ref) {
  var children = _ref.children,
      noPadding = _ref.noPadding;
  return /*#__PURE__*/_jsx(StyledModalContent, {
    noPadding: noPadding,
    className: "modal-content",
    children: children
  });
}

var StyledModalContent = /*#__PURE__*/_styled.div.withConfig({
  displayName: "modal-content__StyledModalContent",
  componentId: "sc-1had00o-0"
})(["", ";", " ", ""], {
  "width": "100%"
}, {
  "paddingTop": "0px",
  "paddingBottom": "0px",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 768px)": {
    "paddingTop": "0px",
    "paddingBottom": "0px",
    "paddingLeft": "2rem",
    "paddingRight": "2rem"
  }
}, function (_ref2) {
  var noPadding = _ref2.noPadding;
  return noPadding ? {
    "padding": "0px",
    "@media (min-width: 768px)": {
      "padding": "0px"
    }
  } : {};
});

export default ModalContent;